<template>
  <div class="wrap">
    <div class="down" @click="download"></div>
  </div>
</template>


<script>
export default {
  name: "Register",
  data() {
    return {
      url: "",
      url2: "",
      download_if: false
    };
  },
  watch: {},

  created() {},

  methods: {
    download() {
      this.app_download(window.download_url);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.down {
  box-sizing: border-box;
  height: 1.3rem;
  width: 100%;
  line-height: 1.3rem;
  border-radius: 0.7rem;
  margin: 0 auto;
  /* background: red; */
  position: relative;
  font-size: 0.48rem;
  font-weight: bold;
  margin-top: 2.4rem;
}
.wrap {
  /* height: 1.6rem; */
  transition-duration: 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/Download.vue